import {Injectable} from "@angular/core";
import {
  Tarification,
  AllPricingFilter,
} from "@icure/api";

import {ApiService} from "./api.service";
import {GROUP_ID_TEMPLATE} from "./tools.service";
import {UtilsService} from "./utils.service";
import {
  COMPLETED, ERROR, WAITING
} from "../../app/private/database/database-group-info/dialogs/code-importation-dialog/code-importation-dialog.component";

@Injectable({
  providedIn: 'root',
})

export class TarificationService {
  constructor(
    private api: ApiService,
    private utils: UtilsService
  ) {
  }

  public async getTarificationByIds(groupId: string, tarificationIds?: string[]): Promise<Tarification[]> {
    return await this.api.tarificationApi.getTarificationsInGroup(groupId, tarificationIds ?? []);
  }

  public getTarificationIds(groupId: string, filter: any): Promise<string[]> {
    return this.api.tarificationApi.matchTarificationsByInGroup(groupId, filter);
  }

  public async injectTarificationIntoDb(targetGroup: string): Promise<{
    injectedCodes: number;
    updatedCodes: number;
    status: string;
  }> {
    const filter: AllPricingFilter = new AllPricingFilter({});
    const idsFromTemplate: string[] = await this.getTarificationIds(GROUP_ID_TEMPLATE, filter) ?? [];
    const existingIdsInTargetDb: string[] = await this.getTarificationIds(targetGroup, filter) ?? [];
    let injectedTarifications: number = 0;
    let updatedTarifications: number = 0;
    if (idsFromTemplate?.length > 0) {
      for (const chunckedIds of this.utils.chunkArray(idsFromTemplate, 100)) {
        try {
          const tarificationsFromTemplate: Tarification[] = await this.getTarificationByIds(GROUP_ID_TEMPLATE, chunckedIds);
          const tarificationsToInject: Tarification[] = tarificationsFromTemplate.filter(c => !existingIdsInTargetDb.includes(c.id!));
          const tarificationsToUpdate: Tarification[] = tarificationsFromTemplate.filter(c => existingIdsInTargetDb.includes(c.id!));
          injectedTarifications += tarificationsToInject?.length ?? 0;
          updatedTarifications += tarificationsToUpdate?.length ?? 0;
          if (tarificationsToInject?.length) {
            tarificationsToInject.map(code => delete code.rev);
            await this.api.tarificationApi.createTarificationsInGroup(targetGroup, tarificationsToInject);
          }
          if (tarificationsToUpdate?.length) {
            const tarificationsFromTarget: Tarification[] = await this.getTarificationByIds(targetGroup, tarificationsToUpdate.map(c => c.id!!));
            const templateByIds: Record<string, Tarification> = Object.fromEntries(tarificationsToUpdate.map(c => [c.id, c]));
            const mergedTarifications: Tarification[] = tarificationsFromTarget.map(targetTarification => {
              const templateTarification = templateByIds[targetTarification.id!];
              if (!templateTarification) return targetTarification;
              const {rev, type, id, version, ...templateData} = templateTarification;
              return {...targetTarification, ...templateData};
            });
            await this.api.tarificationApi.modifyTarificationsInGroup(targetGroup, mergedTarifications);
          }
        } catch (e) {
          return {injectedCodes: injectedTarifications, updatedCodes: updatedTarifications, status: ERROR};
        }
      }
      return {injectedCodes: injectedTarifications, updatedCodes: updatedTarifications, status: COMPLETED};
    }
    return {injectedCodes: 0, updatedCodes: 0, status: WAITING};
  }
}
